/**
 * Created by juzhang on 2018/6/22.
 */
import constants from "./constants";
import "../api/sso/sso";
export default {
  common(result, returnAll) {

    let res = JSON.parse(result);
    if (returnAll) {
      return res;
    }
    if (res.statusCode == constants.interfaceResult.success) {
      //成功
      return res.data;
    } else if (res.statusCode === constants.interfaceResult.noRight) {
      alert("无操作权限!");
     // window.location.href = "login.html";
    } else {
      //对每个业务进行处理，后面再补充
      console.log(res.message);
      console.log("【程序出现异常】");
      if (res.statusCode === "QM-1000"||res.statusCode === "QM-1004") {
        return res;
      } else {
        //问题抛出
        return null;
      }
    }
  },
  //请求异常处理
  doError: function (result, reject) {
    if (!!result.responseText) {
      let response = JSON.parse(result.responseText);
      console.log("【WebApi-ERROR:】" + response.message);
      //token失效，重新登录
      if (response.statusCode === constants.interfaceResult.tokenfail) {
        SSO.getAccessToken(function (item) {
          if (item.result === "success") {
            sessionStorage.setItem("token", item.data.token);
            sessionStorage.setItem("mac", item.data.mac);
            sessionStorage.setItem("tgt", item.data.tgt);
            SSO.setCookie("token", item.data.token, 1);
            window.location.reload();
          } else {
            if (sessionStorage.getItem('isExamClient')) {
              window.parent.postMessage({cmd:'mkClientTokenInvalid'},'*')
            } else{
              window.location.href = "login.html";
            }

          }
        });
      } else if (response.statusCode === constants.interfaceResult.noRight) {
        alert("无操作权限!");
        window.location.href = "login.html";
      } else {
        reject(response.message);
      }
    } else {
      reject("");
    }
  },
};



// WEBPACK FOOTER //
// ./src/common/handleResult.js